import { type ReactNode } from 'react';
import { Skeleton, Badge, BadgeVariant } from '@hungryroot/pho';
import { Heading, Paragraph } from '@hungryroot/ramen';
import styles from './EditBlock.module.css';

interface Props {
  testid?: string;
  heading: string;
  isNew?: boolean;
  description: string;
  icon?: ReactNode;
  onClick?: (() => void) | null;
  isLoading?: boolean;
  className?: string;
  editDisabled?: boolean;
}

export function EditBlock(props: Props) {
  const {
    testid,
    heading,
    isNew,
    description,
    icon,
    onClick,
    isLoading,
    className,
    editDisabled,
  } = props;
  return (
    <div className={`${styles.container} ${className}`}>
      <div data-testid={testid} className={styles.illustration}>
        {icon}
      </div>
      <div data-testid={testid} className={styles.description}>
        <Heading variant="H6" className={styles.heading}>
          <span>{heading}</span>
          {isNew && (
            <Badge variant={BadgeVariant.NewAlt}>
              <Paragraph variant="caption">New</Paragraph>
            </Badge>
          )}
        </Heading>
        {isLoading ? <Skeleton /> : <Paragraph>{description}</Paragraph>}
      </div>
      {onClick && (
        <div className={styles['edit-container']}>
          <Heading variant="H6">
            <button
              aria-label={`Edit ${heading}`}
              data-testid={`${testid}-heading`}
              onClick={onClick}
              className={styles.button}
              disabled={editDisabled}
            >
              Edit
            </button>
          </Heading>
        </div>
      )}
    </div>
  );
}
